/**
 * 新增 编辑
 * @author 3173
 * @description 证书管理 新增/编辑证书
 * @Date  2020/9/10
 */
import React, {Component} from 'react';
import {Form} from 'antd'
import {component_tool, framework_tool} from '@/tool'
import {WizAuthority, WizClassifySelectRe, WizTableForm} from '../../../common'

let {WizAvatarUpload, ossFileUtils} = framework_tool

let {
  WizButton,
  WizSelect,
  WizTooltip,
  WizInput,
  WizIcon,
  WizUpload,
  WizDatePicker,
  WizRow,
  WizCol,
  WizCard,
  WizRadio,
  WizDivider,
  WizCheckbox,
  WizInputNumber,
  Wizmessage,
  WizAlert
} = component_tool;
let WizForm = Form
let Item = Form.Item
let Option = WizSelect.Option

/**
 * 此组件没有继承WizComponent，因为需要使用Form.create()该组件
 * 继承WizComponent后 form的部分功能缺失了
 * 初步怀疑是WizComponent修改了生命周期的钩子导致的
 * by mll 2020-2-4
 */


let cerLevelSociety = [
  {code: 0, msg: '初级'},
  {code: 1, msg: '中级'},
  {code: 2, msg: '高级'}
]
let cerLevelOrgan = [
  {code: 3, msg: '一星'},
  {code: 4, msg: '二星'},
  {code: 5, msg: '三星'},
  {code: 6, msg: '四星'},
  {code: 7, msg: '五星'},
  {code: 8, msg: '六星'},
  {code: 9, msg: '七星'}
]
const levelData = [];
levelData[1]=cerLevelOrgan;
levelData[2]=cerLevelSociety;
class CertForm extends Component {

  constructor(props) {
    super(props);
    let {initialValue} = props;
    this.state = {
      type: initialValue && initialValue.type ? initialValue.type : undefined,
      serial: initialValue && initialValue.serial ? initialValue.serial : undefined,
      code: initialValue && initialValue.code ? initialValue.code : undefined,
      showValidTime: initialValue && initialValue.validTime && initialValue.validTime != -1 ? true : false,
      wizAuthorityKey: 'wizAuthorityKey', //用于处理wizAuthority组件重置不生效问题
      certLevelData: initialValue && initialValue.type ? levelData[initialValue.type] :[],
    }
    this.initialValue = props.initialValue ? props.initialValue : {},
    this.clearWizCallBack = [];
  }

  /** ?提示 */
  _renderCheckTips(tips) {
    if (tips) {
      return (
        <WizTooltip title={tips}>
          <WizIcon type='question-circle-o'/>
        </WizTooltip>
      )
    }
  }

  /**证书编码示例 */
  _examples() {
    let {code, serial} = this.state;
    if (code && serial) {
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth();
      let day = date.getDate();
      if (month) {
        month = month + 1;
        if (month < 10) {
          month = "0" + month;
        }
      }
      if (day) {
        if (day < 10) {
          day = "0" + day;
        }
      }
      let message = "根据证书代码和流水号产生证书编号示例：" + code + year + month + day;
      if (serial > 0) {
        let serialString = "";
        for (let i = 0; i < serial; i++) {
          if (i == serial - 1) {
            serialString += "1"
          } else {
            serialString += "0"
          }
        }
        message += serialString;
      }
      return (
        <WizRow>
          <WizCol md={24} lg={24}>
            <WizAlert message={message} type="info" showIcon/>
          </WizCol>
        </WizRow>
      )
    }
    return null;
  }

  /**证书有效期显示内容 */
  _validTime() {
    const {getFieldDecorator} = this.props.form;
    if (this.state.showValidTime && this.state.showValidTime != -1) {
      return (
        <WizRow>

          <WizCol>有效期 &nbsp;
            {getFieldDecorator('validTime', {
              initialValue: this.initialValue.validTime && this.initialValue.validTime != -1 ? this.initialValue.validTime : 1
            })(
              <WizInputNumber min={1} max={99}/>
            )}
            &nbsp;月（最低1个月）
          </WizCol>

        </WizRow>
      )
    }
    return null
  }

  /**
   * 表单基础内容
   *  Item hasFeedback 展示校验状态图标
   */
  _base() {
    const {getFieldDecorator} = this.props.form;
    let {certLevelData} = this.state;
    let items = [
      <Item label="证书名称">
        {getFieldDecorator('name', {
          rules: [{required: true, message: '请输入证书名称'}],
          initialValue: this.initialValue.name,
          initRows: []
        })(<WizInput maxlength={30} placeholder='请输入证书名称,最多输入30个字'/>)}
      </Item>,
      <Item label="证书分类">
        {getFieldDecorator('categoryIds', {
          rules: [{type: 'array'}, {required: true, message: '请选择证书分类'}],
          initialValue: this.initialValue.categoryIds ? this.initialValue.categoryIds : [],
        })(<WizClassifySelectRe
          returnKey={true}
          apiProps={{type: 13}}
          initSelects={this.initialValue.categoryInfo ? this.initialValue.categoryInfo : []}
          wizTreeSelectListProps={{
            itemProps: {
              icon: 'unordered-list',
              title: '证书分类',
              tips: '请勾选证书分类'
            },
            treeProps: {checkStrictly: true}
          }}
          onClearWiz={this._onClearWiz.bind(this)}/>)}
      </Item>,
      <Item label="适用范围">
        {getFieldDecorator('authCmd', {
          initialValue: this.initialValue.authData,
          rules: [{required: true, message: '请选择适用范围'}],
        })(
          <WizAuthority
            key={this.state.wizAuthorityKey}
            mode={'Form'}
            // classname={'demo-authority'}
            keys={['orgIds', 'positionIds', 'positionCategoryIds', 'personIds']}
            keyConfig={{
              orgIds: {
                title: '组织选择',
                config: WizTableForm.Config.organization(this, {apiParams: {state: 1}})
              }
            }}
          />
        )}
      </Item>,
      <Item label="证书类型">
        {getFieldDecorator('classify', {
          initialValue: this.initialValue.classify,
          rules: [{required: true, message: '请选择证书类型'}],
        })(
          <WizSelect placeholder="请选择证书类型" disabled={this.initialValue.classify}>
            <Option value={1}>个人</Option>
            <Option value={2}>店端</Option>
          </WizSelect>
        )}
      </Item>,
      <Item label="证书类别">
        {getFieldDecorator('type', {
          initialValue: this.initialValue.type,
          rules: [{required: true, message: '请选择证书类别'}],
        })(
          <WizSelect
            placeholder="请选择证书类别"
            // labelInValue
            onChange={(type, option) => this._handleTypeChange(type, option)}
            disabled={this.initialValue.type}
          >
            <Option value={1}>培训</Option>
            <Option value={2}>社会</Option>
          </WizSelect>
        )}
      </Item>,
      <Item label="证书级别">
        {getFieldDecorator('level', {
          initialValue: this.initialValue.level,
          rules: [{required: true, message: '请选择证书级别'}],
        })(
          <WizSelect placeholder="请选择证书级别" disabled={this.initialValue.level}>
            {certLevelData.length > 0 ? (certLevelData.map(level =><Option value={level.code}>{level.msg}</Option>)) : null}
          </WizSelect>
        )}
      </Item>,
    ]
    return items
  }

  _handleTypeChange = (type, option) => {
    //option 1:培训；2：社会
    let certLevelData = [];
    if (type) {
      certLevelData = levelData[type];
    }
    if (!certLevelData){
      certLevelData = [];
    }
    this.setState({
      type: type,
      certLevelData: certLevelData,
    })
  }

  /**培训证书展示的数据 */
  _train() {
    //流水号多余的:不要删掉，不知道为什么显示的时候会吞掉最后一个字符
    const {getFieldDecorator} = this.props.form;
    let items = [
      <Item label="证书代码" layout="inline" extra={this._examples()}>
        <WizRow>
          <WizCol span={8}>
            <Item colon={false} style={{display: 'inline-block', marginBottom: 0,}}>
              {getFieldDecorator('code', {
                initialValue: this.initialValue.code,
                rules: [
                  {
                    pattern: /^[A-Za-z0-9-_]+$/,
                    message: '证书代码仅支持数字、字母、-、_'
                  }],
              })(<WizInput disabled={this.initialValue.id} maxlength={30} placeholder='请输入证书代码' onChange={(value) => {
                this.setState({code: value.target.value})
              }}/>)}
            </Item>
          </WizCol>
          <WizCol span={15}>
            <Item label="流水号：&nbsp;:" style={{display: 'inline-block', marginBottom: 0,}}
                  wrapperCol={{
                    xs: {span: 10, offset: 1},
                    sm: {span: 10, offset: 1},
                  }}
                  labelCol={{
                    xs: {span: 7, offset: 1},
                    sm: {span: 7, offset: 1},
                  }}>
              {getFieldDecorator('serial', {
                initialValue: this.initialValue.serial && this.initialValue.serial != -1 ? this.initialValue.serial : undefined
              })(<WizInputNumber disabled={this.initialValue.id} min={1} max={10} onChange={(value) => {
                if(value>0 && value<=10){
                  this.setState({serial: value})
                }
              }}/>)}

            </Item>
            {this._renderCheckTips('证书编码规则：证书代码(证书名称字母缩写)+默认日期+流水号。例：TY20200902000001')}
          </WizCol>
        </WizRow>
      </Item>,
      <Item label="永久有效期">
        <WizRow>
          <WizCol>
            {getFieldDecorator('showValidTime', {
              initialValue: this.initialValue.validTime && this.initialValue.validTime != -1 ? 1 : 0
            })(
              <WizRadio.Group onChange={(e) => {
                let isShow = e.target.value == 0 ? false : true;
                this.setState({showValidTime: isShow})
              }}>
                <WizRadio value={0}>是</WizRadio>
                <WizRadio value={1}>否</WizRadio>
              </WizRadio.Group>
            )}
          </WizCol>
        </WizRow>
        {this._validTime()}
      </Item>
    ];

    return items
  }

  /**社会证书展示的数据 */
  _society() {
    const {getFieldDecorator} = this.props.form;
    return null
  }

  /**
   * 拓展属性
   */
  _ext = () => {
    if (this.state.type === 1) {
      return this._train()
    }
    return null;
  }

  _ext2() {
    const {getFieldDecorator} = this.props.form;
    //if (this.state.type) {
    return (
      <>
        <Item label="是否允许申请">
          {getFieldDecorator('needCheck', {
            initialValue: this.initialValue.needCheck ? this.initialValue.needCheck : 0
          })(
            <WizRadio.Group>
              <WizRadio value={0}>否</WizRadio>
              <WizRadio value={1}>是</WizRadio>
            </WizRadio.Group>
          )}
          {this._renderCheckTips('设置为"是"则该证书在学员端可允许申请且该证书需要审核。')}
        </Item>
        <Item label="证书图标"
          label={ <span>
                        证书图标&nbsp;
                        <WizTooltip title="请上传大小不超过2MB,图片尺寸建议800*800">
                            <WizIcon type="question-circle-o" />
                        </WizTooltip>
                  </span>
                }>
          {getFieldDecorator('icon', {
            initialValue:
              (this.initialValue && this.initialValue.icon) ? [
                {fileId: this.initialValue.icon}
              ] : []
          })(
            <WizAvatarUpload
              accept={'.jpg, .jpeg, .png'}
              listType={'picture-card'}
              aspectRatio={1 / 1}
              beforeUpload={(file) => {
                let result = true;
                const isLt1M = file.size / 1024 / 1024 < 2;
                if (file.type.indexOf('image/') == -1) {
                  Wizmessage.error('只能上传图片类型,请重新选择!');
                  result = false;
                } else if (!isLt1M) {
                  Wizmessage.error('图片不得超过2M!');
                  result = false;
                }
                return result;
              }}
            />
          )}
        </Item>
        <Item label="状态">
          {getFieldDecorator('state', {
            initialValue: this.initialValue.state || this.initialValue.state == 0 ? this.initialValue.state : 1
          })(
            <WizRadio.Group>
              <WizRadio value={1}>有效</WizRadio>
              <WizRadio value={0}>无效 </WizRadio>
            </WizRadio.Group>
          )}
        </Item>
      </>
    )
    //  }
    //  return null;
  }


  /**
   * 表单提交按钮
   */
  _submit() {
    return (
      <Item wrapperCol={{span: 12, offset: 6}}>
        <WizRow>
          <WizCol span={24} style={{textAlign: 'center'}}>
            <>
              <WizButton style={{marginLeft: 20}} title="保存" type="primary" htmlType="submit">保存</WizButton>
              <WizButton style={{marginLeft: 20}} onClick={this.handleReset}>重置</WizButton>
            </>
          </WizCol>
        </WizRow>
      </Item>
    )
  }

  /**
   * 处理表单提交事件
   */
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        if (this.props.onSubmit) {

          this.props.onSubmit(values);
        }
      }
    });
  };


  /**
   * 重置表单
   */
  handleReset = () => {
    this.props.form.resetFields();
    this.clearWizCallBack.forEach(callback => {
      callback && callback()
    })
    let type = this.initialValue && this.initialValue.type ? this.initialValue.type : undefined;
    let serial = this.initialValue && this.initialValue.serial ? this.initialValue.serial : undefined;
    let code = this.initialValue && this.initialValue.code ? this.initialValue.code : undefined;
    let showValidTime = this.initialValue && this.initialValue.validTime && this.initialValue.validTime != -1 ? true : false;
    this.setState({
      type: type,
      serial: serial,
      code: code,
      showValidTime: showValidTime,
      wizAuthorityKey: 'wizAuthorityKey' + new Date().getTime()
    })
  };

  _onClearWiz(callback) {
    if (callback) {
      this.clearWizCallBack.push(callback)
    }
  }


  render() {
    const {getFieldDecorator} = this.props.form;
    const {title} = this.props;
    const formItemLayout = {
      labelCol: {span: 6},
      wrapperCol: {span: 14},
    };

    return (
      <WizCard>
        <WizForm
          {...formItemLayout}
          onSubmit={this.handleSubmit}
        >
          {this._base()}
          {this._ext()}
          {this._ext2()}
          {this._submit()}
        </WizForm>
      </WizCard>
    )

  }
}

export default WizForm.create()(CertForm);


